export const merchantIdentifier = "merchant.com.adeb1991.explicationyourdream";
export const merchantDisplay = "NAEM";
export const paymentRequestApi = "no";

export const APPLE_PAY_VERSION_NUMBER = 3;
